import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { updateUserInfo } from "./components/common/Redux/userInfo";
import { AuthStateContext } from "./AuthContext";

import EquipmentManagement from "./components/EquipmentManagement";
import QR from "./components/EquipmentManagement/QR";
import Main from "./components/Main";
import ClinicTestOprtnInsttInfoService01 from "./components/openAPI/ClinicTestOprtnInsttInfoService01";
import Indication from "./components/openAPI/Indication";
import MdcinClincTestInfoService01 from "./components/openAPI/MdcinClincTestInfoService01";
import Visualization from "./components/openAPI/Visualization";
import SOPViewer from "./components/SOPViewer";
import Training from "./components/Training";
import ContractRegistration from "./components/ProjectSetup/ContractRegistration";
import ProjectAssign from "./components/ProjectSetup/ProjectAssign";
import WorkingTimeTable from "./components/WorkingTimeTable";
import ProjectSetup from "./components/ProjectSetup";
import Organization from "./components/Organization";
import CurriculumVitae from "./components/CurriculumVitae";
import PersonalRecord from "./components/PersonalRecord";
import QnABoard from "./components/BulletinBoard/QnABoard";
import QnADetail from "./components/BulletinBoard/QnADetail";
import AuditDocumentViewer from "./components/AuditDocumentViewer";
import ReleaseNotes from "./components/ReleaseNotes";
import MonthlyReport from "./components/MonthlyReport";
import SalesManagement from "./components/SalesManagement";
import Feasibility from "./components/Feasibility";
import FeasibilitySite from "./components/FeasibilitySite";
import ProtectedRoute from "./ProjectedRoute";
import MedicalDeviceClinicalTrials from "./components/openAPI/MedicalDeviceClinicalTrials";
import MedicalDeviceInstitutions from "./components/openAPI/MedicalDeviceInstitutions";

const router = createBrowserRouter([
  { path: "/", element: <Main /> },
  { path: "sfq-site/:token", element: <FeasibilitySite /> },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "EqptMgmt", element: <EquipmentManagement /> },
      { path: "EqptMgmt/:type/:SEQ", element: <QR /> },
      { path: "MdcinClincTestInfoService01", element: <MdcinClincTestInfoService01 /> },
      { path: "ClinicTestOprtnInsttInfoService01", element: <ClinicTestOprtnInsttInfoService01 /> },
      { path: "MedicalDeviceClinicalTrials", element: <MedicalDeviceClinicalTrials /> },
      { path: "MedicalDeviceInstitutions", element: <MedicalDeviceInstitutions /> },
      { path: "Indication", element: <Indication /> },
      { path: "SOPViewer", element: <SOPViewer /> },
      { path: "LrnMgmt", element: <Training /> },
      { path: "Adt", element: <AuditDocumentViewer /> },
      { path: "PrjSu", element: <ProjectSetup /> },
      { path: "ContrReg", element: <ContractRegistration /> },
      { path: "PrjAsgmt", element: <ProjectAssign /> },
      { path: "WorkR", element: <WorkingTimeTable /> },
      { path: "Visualization", element: <Visualization /> },
      { path: "Org", element: <Organization /> },
      { path: "CV", element: <CurriculumVitae /> },
      { path: "PersRcrd", element: <PersonalRecord /> },
      { path: "qna", element: <QnABoard /> },
      { path: "qna/:id", element: <QnADetail /> },
      { path: "RelNotes", element: <ReleaseNotes /> },
      { path: "MthlyReport", element: <MonthlyReport /> },
      { path: "SalesMgmt", element: <SalesManagement /> },
      { path: "Feasibility", element: <Feasibility /> },
      { path: "Feasibility/:sfqId", element: <Feasibility /> },
      { path: "Feasibility/:sfqId/:invId", element: <Feasibility /> },
    ],
  },
]);

export default function App() {
  const dispatch = useDispatch();
  const [authState, setAuthState] = useState({ checked: false, authenticated: false });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/common/auth/me`)
      .then((res) => {
        if (res?.data?.authenticated) {
          dispatch(updateUserInfo(res.data));
          setAuthState({ checked: true, authenticated: true });
        } else {
          setAuthState({ checked: true, authenticated: false });
        }
      })
      .catch(() => setAuthState({ checked: true, authenticated: false }));
  }, []);

  return (
    <AuthStateContext.Provider value={{ ...authState, setAuthState }}>
      <RouterProvider router={router} />
    </AuthStateContext.Provider>
  );
}
